import { DOCUMENT_VIEW_SUCCESS } from "./view";

export const DOCS_REQUEST = "Docs.Request";
export const DOCS_SUCCESS = "Docs.Success";
export const DOCS_FAILURE = "Docs.Failure";

export function fetchDocs(filter, signal) {
  return (dispatch, getState) => {
    const { auth } = getState();
    const request = () => {
      if (filter.scope !== "all") {
        return filter.scope === "general"
          ? `/api/pub/documents?page=${filter.page}`
          : `/api/documents?scope=${filter.scope}&page=${filter.page}`;
      } else {
        return `/api/documents?page=${filter.page}`;
      }
    };

    dispatch({ type: DOCS_REQUEST, payload: filter.scope});
    return fetch(request(), {
      headers: {
        Authorization: `Bearer ${auth.token}`,
      },
      signal,

    }).then(async (response) => {
        const data = await response.json();
          // data.result.list[0].cancelled = true;
          if (data.status === "success") {
              dispatch({
                type: DOCS_SUCCESS,
                payload: { scope: filter.scope, ...data.result },
              });
            } else {
              dispatch({
                type: DOCS_FAILURE,
                payload: data,
              });
            }
          }).catch((e) => {
            console.log(e);
          });
        };
      }

export const DOCS_RESET = "Docs.Reset";
export const DOCS_SELECT = "Docs.Select";
export const DOCS_UPDATE = "Docs.Update";

export function selectDocs(docs: Array<string>, checked: boolean) {
  return {
    type: DOCS_SELECT,
    payload: docs.reduce((memo, el) => {
      memo[el] = checked;
      return memo;
    }, {}),
  };
}

export function inprogressDocs() {
  return (dispatch, getState) => {
    let inprogress = false;
      setInterval(() => {
        const { auth, docs } = getState();
        if (!auth.token || inprogress) {
          return false;
        }
        inprogress = true;
        docs.list.filter((el) => el.error?.code === 115).reduce((promise, el) => {
          return promise.then(() => fetch(`/api/documents/${el.id}`, {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          })).then(async (response) => {
            const data = await response.json();
            if (data.status === "success" && data.result.error?.code !== 115) {
              dispatch({
                type: DOCS_UPDATE,
                payload: { [el.id]: data.result },
              });
            }
          });
        }, Promise.resolve()).then(() => {
          const { view } = getState();
          if (view.error?.code === 115) {
            return fetch(`/api/documents/${view.id}`, {
              headers: {
                Authorization: `Bearer ${auth.token}`,
              },
            }).then(async (response) => {
              const data = await response.json();
              if (data.status === "success" && data.result.error?.code !== 115) {
                dispatch({
                  type: DOCUMENT_VIEW_SUCCESS,
                  payload: data.result,
                });
              }
            });
          }
        }).finally(() => {
          inprogress = false;
        });
      }, 1500);
    };
  }
  
